import React from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, ButtonToolbar } from 'rsuite';
import { Field } from './common/Field'
import AuthLayout, { authCardClass, focusFirstError } from './common/AuthLayout';
import { toast } from 'react-toastify';
import { Validator } from "@rsuite/validation";
import { scrollToTop } from '../utils/scrollUtils';

const apiUrl = process.env.REACT_APP_SERVER_API_URL;

const model = Validator.SchemaModel({
    email: "required|email",
    password: "required|min:6",
});

const Login = () => {
    const [formValue, setFormValue] = React.useState({ email: '', password: '' });
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const navigate = useNavigate();

    const formRef = React.useRef();

    const login = () => {
        if (!formRef.current.check()) {
            focusFirstError();
            return;
        }

        setIsSubmitting(true);
        const loginUser = { email: formValue.email, password: formValue.password };
        axios.post(`${apiUrl}/users/login`, loginUser)
            .then((loginResponse) => {
                localStorage.setItem("auth-token", loginResponse.data.token);
                localStorage.setItem("user-id", loginResponse.data.user.id);

                // Check if user has kids to determine redirect destination
                const userId = loginResponse.data.user.id;
                const token = loginResponse.data.token;

                axios.get(`${apiUrl}/users/${userId}/kids`, {
                    headers: { 'x-auth-token': token }
                })
                .then((kidsResponse) => {
                    const kids = kidsResponse.data;
                    if (kids && kids.length > 0) {
                        // User has kids - redirect to Book a camp
                        navigate("/book");
                    } else {
                        // User has no kids - redirect to Manage Kids
                        navigate("/manage");
                    }
                    scrollToTop();
                })
                .catch(() => {
                    // If kids fetch fails, default to home page
                    navigate("/");
                    scrollToTop();
                });
            })
            .catch(() => {
                setIsSubmitting(false);
                toast.error('Email or password is incorrect. Please try again.', { position: "top-center" });
            });
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            login();
        }
    }


    return (

        <AuthLayout>
            <Form
                ref={formRef}
                onChange={setFormValue}
                formValue={formValue}
                model={model}
                className={authCardClass('compact') + ' auth-form'}
                size="full"
                onKeyDown={handleKeyDown}
            >

                <Field
                    name="email"
                    label="Email"
                    autoFocus
                    autoCapitalize="off"
                    type="email"
                    autoComplete="email"
                />

                <Field
                    name="password"
                    label="Password"
                    type='password'
                    autoComplete="current-password"
                >
                </Field>

                <ButtonToolbar>
                    <Button
                        appearance="primary"
                        onClick={login}
                        block
                        loading={isSubmitting}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Logging in...' : 'Log In'}
                    </Button>
                    <Link to="../forgotPassword"
                    state={{ email: formValue.email }}
                    className="mt-3 block w-full no-underline text-blue-600 hover:text-blue-800 text-sm text-center"
                    >Forgot password?</Link>
                    <div className="w-full border-t border-gray-200 mt-4 pt-3 text-center text-sm text-gray-600">
                        New to Newtonshow?{' '}
                        <Link to="../register" className="no-underline text-blue-600 hover:text-blue-800 font-medium">
                            Create an account
                        </Link>
                    </div>
                </ButtonToolbar>

            </Form>
        </AuthLayout>
    )
}

export default Login;
